module.exports = __webpack_public_path__ + "img/logo.103f912c.png";